import React, { useState, useEffect } from "react";
import {
  Avatar,
  Box,
  Button,
  Dialog,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { MoreHoriz } from "@mui/icons-material";
import { apicallDeteleUserAccount, apiCallRestoreAccount, apiCallUserList } from "../../../../Core/Apicall";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../../Redux/Store";
import CommonShimmer from "../../../Common/CommonShimmer/CommonShimmer";
import DeletePopup from "../../../Common/DeletePopup/DeletePopup";
import CommonMenu from "../../../Common/CommonMenu/CommonMenu";
import CommonPagination from "../../../Common/CommonPagination/CommonPagination";
import EmptyData from "../../../Common/EmptyData/EmptyData";
import { useDebounce } from "../../../Common/UseDebounce/useDebounce";
import { usePaginationState } from "../../../../hooks/usePaginationState";
import InputAdornment from "@mui/material/InputAdornment";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { toast } from "react-toastify";

export type User = {
  _id: string;
  emailId: string;
  phoneNumber: string;
  phoneCountryCode: string;
  socialLoginType: string;
  isDelete: boolean;
  dateOfBirth: string;
  fullName: string;
  gender: string;
  profileImagePath: string;
  isApproved: boolean;
  role: number;
  addressType: string;
  city: string;
  zipCode: string;
  country: string;
  stateOrRegion: string;
  latitude: number;
  longitude: number;
  addressIsDelete: boolean;
};
type CommonUserTableProps = {
  role: number;
  onEdit?: (user: any) => void;
  onCreate?: () => void;
};

function CommonUserTable({ role, onEdit, onCreate }: CommonUserTableProps) {
  const [data, setData] = useState<User[]>([]);
  // const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [search, setSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [menuUser, setMenuUser] = useState<User | null>(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [totalItems, settotalItems] = useState<any>();
  const [selectedMediaForPreview, setSelectedMediaForPreview] = useState<
    any | null
  >(null);

  const {
    page,
    search,
    setSearch,
    debouncedSearch,
    handlePageChange,
    setPage,
  } = usePaginationState();



  const userdata: any = useSelector((state: RootState) => state.global.token);

  const navigate = useNavigate();
  const totalPages = Math.ceil(totalItems / rowsPerPage);
  const fetchVenues = async () => {
    setLoading(true);
    try {
      const response = await apiCallUserList({
        userId: userdata?.data?.userId,
        role,
        search: debouncedSearch,
        offset: page,
        limit: rowsPerPage,
      });
      if (response?.data) {
        setData(response.data);
        settotalItems(response?.totalCount);
      } else {
        setData([]);
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVenues();
  }, [page, rowsPerPage, debouncedSearch]);


  const handleUserStatus = async () => {
    if (!menuUser) return;
    try {
      const params = {
        userId: menuUser._id,
      };
      if (menuUser.isDelete) {
        await apiCallRestoreAccount(params);
        toast.success("User activated successfully");
      } else {
        await apicallDeteleUserAccount(params);
        toast.success("User deleted successfully");
      }
      setData((prev) =>
        prev.map((user) =>
          user._id === menuUser._id
            ? { ...user, isDelete: !user.isDelete }
            : user
        )
      );
      setDeleteDialogOpen(false);
      setMenuUser(null);
    } catch (error) {
      toast.error("Something went wrong");
      console.error(error);
    }
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, user: User) => {
    setAnchorEl(event.currentTarget);
    setMenuUser(user);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const menuItems = [
    ...(role === 6
      ? [
        {
          label: "Edit",
          onClick: () => onEdit && menuUser && onEdit(menuUser),
        },
      ]
      : []),

    {
      label: menuUser?.isDelete ? "Activate" : "Delete",
      onClick: () => setDeleteDialogOpen(true),
    },
  ];

  return (
    <Box style={{ paddingBottom: "20px" }}>
      <Box className="d-flex input align-items-center justify-content-between">
        <TextField
          className="border-10"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search..."
          sx={{ backgroundColor: "white", width: "300px" }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),

            endAdornment: search && (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onClick={() => setSearch("")} // ✅ Clear Search
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <Box className="d-flex gap-3 align-items-center">
          {/* <Button
            onClick={() => navigate("/admin/AddUser")}
            className="btn-black p-2 px-3"
          >
            + Create New
          </Button> */}
          {role === 6 ? (
            <Button
              onClick={onCreate}
              className="btn-black p-2 px-3"
            >
              + Create Public User
            </Button>
          ) : null}
        </Box>
      </Box>
      <Paper
        className="bg-white mt-3 border-20 scroll-bar"
        sx={{ borderRadius: 3, overflow: "hidden" }}
      >
        <TableContainer className="scroll-bar">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>User</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Phone</TableCell>
                <TableCell>City</TableCell>
                <TableCell>Country</TableCell>
                <TableCell>Status</TableCell>
               {role != 2 &&  <TableCell>Action</TableCell>}
              </TableRow>
            </TableHead>
            {loading === false && (
              <TableBody>
                {data.map((user: any) => (
                  <TableRow hover key={user._id}>
                    <TableCell>
                      <div
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          gap: "10px",
                        }}
                      >
                        {user?.profileImagePath ? (
                          <Avatar
                            src={user.profileImagePath}
                            alt="Profile"
                            sx={{ width: 50, height: 50, cursor: "pointer" }}
                            onClick={() =>
                              setSelectedMediaForPreview({
                                url: user.profileImagePath,
                              })
                            }
                          />
                        ) : (
                          "-"
                        )}
                        <div
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                          }}
                          onClick={() => {
                            if (role === 5) {
                              navigate("/admin/VenueOwnerDetails", {
                                state: { user },
                              });
                            } else if (role === 6) {
                              navigate("/admin/PublicUserDetails", {
                                state: { user },
                              });
                            } else {
                              navigate("/admin/UserDetails", {
                                state: { user },
                              });
                            }
                          }}
                        >
                          {user.fullName}
                          {user.isDelete && (
                            <span
                              style={{
                                width: "10px",
                                height: "10px",
                                backgroundColor: "#ff4d4f",
                                borderRadius: "50%",
                                marginLeft: 5,
                                display: "inline-block",
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </TableCell>
                    <TableCell
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        if (role === 5) {
                          navigate("/admin/VenueOwnerDetails", {
                            state: { user },
                          });
                        } else if (role === 6) {
                          navigate("/admin/PublicUserDetails", {
                            state: { user },
                          });
                        } else {
                          navigate("/admin/UserDetails", { state: { user } });
                        }
                      }}
                    >
                      {user.displayEmailId ?? user.emailId}
                    </TableCell>
                    <TableCell
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        if (role === 5) {
                          navigate("/admin/VenueOwnerDetails", {
                            state: { user },
                          });
                        } else if (role === 6) {
                          navigate("/admin/PublicUserDetails", {
                            state: { user },
                          });
                        } else {
                          navigate("/admin/UserDetails", { state: { user } });
                        }
                      }}
                    >
                      {user.phoneCountryCode}{" "}
                      {user.phoneNumber ? user.phoneNumber : "-"}
                    </TableCell>
                    <TableCell
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        if (role === 5) {
                          navigate("/admin/VenueOwnerDetails", {
                            state: { user },
                          });
                        } else if (role === 6) {
                          navigate("/admin/PublicUserDetails", {
                            state: { user },
                          });
                        } else {
                          navigate("/admin/UserDetails", { state: { user } });
                        }
                      }}
                    >
                      {user.city ? user.city : "-"}
                    </TableCell>
                    <TableCell
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        if (role === 5) {
                          navigate("/admin/VenueOwnerDetails", {
                            state: { user },
                          });
                        } else if (role === 6) {
                          navigate("/admin/PublicUserDetails", {
                            state: { user },
                          });
                        } else {
                          navigate("/admin/UserDetails", { state: { user } });
                        }
                      }}
                    >
                      {user.country ? user.country : "-"}
                    </TableCell>
                    <TableCell style={{ cursor: "pointer" }}>
                      <Button
                        className={
                          user.isApproved ? "btn-success" : "btn-danger"
                        }
                      >
                        {user.isApproved ? "Approved" : "Pending"}
                      </Button>
                    </TableCell>
                    {role != 2 && <TableCell>
                      <IconButton onClick={(e) => handleMenuOpen(e, user)}>
                        <MoreHoriz />
                      </IconButton>
                    </TableCell>
                    }
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>
          {loading === true && (
            <div style={{ padding: "10px 10px" }}>
              <CommonShimmer />
            </div>
          )}
        </TableContainer>
        {loading === false && <EmptyData data={data} />}
        <CommonPagination
          page={page}
          rowsPerPage={rowsPerPage}
          totalItems={totalItems}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          onRowsPerPageChange={(value) => {
            setRowsPerPage(value);
          }}
        />
      </Paper>
      {role != 2 && <CommonMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        items={menuItems}
      />
      }
      <Dialog
        open={!!selectedMediaForPreview}
        onClose={() => setSelectedMediaForPreview(null)}
      >
        <Avatar
          src={selectedMediaForPreview?.url}
          variant="rounded"
          sx={{ width: 200, height: "auto" }}
        />
      </Dialog>
      <DeletePopup
        open={deleteDialogOpen}
        title={menuUser?.isDelete ? "Activate User" : "Confirm Delete"}
        message={
          menuUser?.isDelete
            ? "Are you sure you want to activate this user?"
            : "Are you sure you want to delete this user?"
        }
        confirmText={menuUser?.isDelete ? "Activate" : "Delete"}
        cancelText="Cancel"
        onConfirm={handleUserStatus}
        onClose={() => setDeleteDialogOpen(false)}
      />
    </Box>
  );
}

export default CommonUserTable;
